module.exports = __webpack_public_path__ + "static/Rat.6da9a05e.png";